import usagePageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  selectedUsageCycleId: null,
};

const reducer = createReducer(INITIAL_STATE, {
  [usagePageActionTypes.SET_SELECTED_USAGE_CYCLE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      selectedUsageCycleId: action.id,
    };
  },
});

export default reducer;
